export const HOST = 'https://api.fotograf-novisad.com/api'
export const STORAGE = 'https://api.fotograf-novisad.com/storage'
